export default "__VITE_ASSET__85aa17a3__"